var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"text"},[_vm._v("Please contact us via following email address")]),_c('div',{staticClass:"text email"},[_vm._v("info@jfmobility.com")])])])
}]

export { render, staticRenderFns }